import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/ClockClockwise.es.js";
const c = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...e, weights: t }));
c.displayName = "ClockClockwiseIcon";
const l = c;
export {
  l as ClockClockwise,
  c as ClockClockwiseIcon
};
